/* Raghu  26/10/2022   3075154998   Inputfields Alignments and Enhancements
akhila    10/28/2022 3075154998 enable framework UX changes
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions
akhila 11/01/2022 3075154998 TablePagination bugFix
Suresh Peddavoora 11/03/2022 3075154998 Table Pagination Tab Responsive Fixes

*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchFilterGroup,
  postFilterGroup,
  ResetMessage as resetMessage,
} from '../../../../../redux/reducers/EnableFramework/FilterGroup';
import PageLoader from '../../../../../components/PageLoader';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';

export default function FilterGroupSearchTable({
  submit,
  setSubmit,
  setSelectedFilterGroupCode,
  searchData,
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setRecordFormatFilterGroupId,
  setFilterGroupCode,
  setIsCopyRowData,
}) {
  const [message, setMessage] = useState('');
  const {printStatus, errorMsg, isLoading, successMsg} = useSelector(
    ({filterGroup}) => filterGroup,
  );
  const columns = [
    {
      title: 'Filter Group Code',
      field: 'filterGroupCode',
    },
    {
      title: 'Filter Group Name',
      field: 'filterGroupName',
    },
    {
      title: 'Filter Group Description',
      field: 'filterGroupDescription',
    },
  ];

  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [status, setStatus] = useState(false);
  const dispatch = useDispatch();
  setFilterGroupCode('');
  useEffect(() => {
    if (printStatus === 200 || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [printStatus, errorMsg]);
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  useEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    httpPaginationDelete(`enableintegration/delete/filtergroup/${deleteData?.filterGroupId}`)
      .then((response) => {
        if (response?.status === 200) {
          setMessage(response?.response);
          setTimeout(() => {
            setMessage('');
          }, 3000);
          setIsDelete(false);
          setStatus(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Filter Group"
        value={`Are you sure you want to delete this filter group?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon ">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `enableintegration/search/filtergroup`;
                const bodyObj = {
                  filterGroupDescription: searchData?.description ? searchData?.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  filterGroupCode: searchData?.code ? searchData.code : '',
                  filterGroupName: searchData?.displayName ? searchData.displayName : '',
                  page:
                    submit ?
                      1 :
                      arrayLast && query.page >= 1 ?
                        query.page :
                        arrayLast ?
                          (query.page <= 1 && query.page + 1) || query.page - 1 :
                          query.page + 1,
                  orderDirection: query.orderDirection,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setSubmit(false);
                        setArrayLast(data.length === 1);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              toolbar: true,
              toolbarButtonAlignment: 'left',
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            localization={{
              body: {
                editRow: {deleteText: 'Are you sure you want to delete this filter group?'},
              },
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}

                    >
                      Add Filter Group
                    </Button>
                  </>
                ),
                tooltip: '',
                isFreeAction: true,
                onClick: (event) => {
                  setTabValue(1);
                },
              },
              {
                icon: () => (
                  <>
                    <FileCopyOutlinedIcon />
                  </>
                ),
                tooltip: 'copy',
                onClick: (event, rowData) => {
                  setFilterGroupCode(rowData?.filterGroupCode);
                  dispatch(fetchFilterGroup(rowData.filterGroupId));
                  setTabValue(1);
                  setIsCopyRowData(true);
                },
              },
              (rowData) => {
                return {
                  icon: () => <DeleteOutlineOutlinedIcon/>,
                  tooltip: 'Delete',
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
            ]}
            onRowClick={(event, rowData) => {
              if (handleClose && setRecordFormatFilterGroupCode) {
                setRecordFormatFilterGroupCode(rowData.filterGroupCode);

                handleClose();
              } else if (handleClose) {
                setSelectedFilterGroupCode(rowData.filterGroupCode);

                dispatch(fetchFilterGroup(rowData.filterGroupId));
                handleClose();
              } else {
                setTabValue(1);
                setFilterGroupCode(rowData?.filterGroupCode);

                dispatch(fetchFilterGroup(rowData.filterGroupId));
              }
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      color="primary"
                      onClick={() => {
                        dispatch(
                          postFilterGroup({
                            filterGroupDescription: searchData?.description ?
                              searchData?.description :
                              '',
                            filterGroupCode: searchData?.code ? searchData.code : '',
                            filterGroupName: searchData?.displayName ? searchData.displayName : '',
                          }),
                        );
                      }}
                    >
                      Print
                    </Button>
                  </div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
          {isLoading && <PageLoader />}
          {successMsg && <SuccessSnackbar successMsg={successMsg} />}
          {message && <SuccessSnackbar successMsg={message} />}
        </div>
      </Grid>
    </>
  );
}
